import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BasePage from "../../../../Components/BasePage";
import TableComponent from "../../../../Components/Table/TableComponent";
import { getPayedaTokenLogs } from "../../../../store/actions/bankingActions";
import { Typography, Grid } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";

const TransferMoney = ({ business }) => {
  const dispatch = useDispatch();

  const [selected, setSelected] = useState([]);
  let transactionsLoading = useSelector((state) => state.banking.loading);
  let tokenLogs = useSelector((state) => state.banking.tokenLogs);
  const user = useSelector((state) => state.user);

  // useEffect(() => {
  //   if (user?.permissions?.tokenSpending?.view) {
  //     dispatch(getPayedaTokenLogs());
  //   }
  //   // eslint-disable-next-line
  // }, []);

  const headCells = [
    { id: "debit", label: "Amount Spent" },
    { id: "balance", label: "Balance" },

    { id: "token_type", label: "Type" },
    { id: "description", label: "Description" },
  ];

  const renderTransactionsTable = () => {
    return (
      <>
        <TableComponent
          data={tokenLogs?.data || []}
          selected={selected}
          setSelected={setSelected}
          headCells={headCells}
          isLoading={transactionsLoading}
          shouldGetData={true}
          getAllData={getPayedaTokenLogs}
          numberOfPages={tokenLogs?.data?.number_of_page ? tokenLogs.data.number_of_page : 0}
        />
      </>
    );
  };

  const renderPackageInfo = () => {
    return (
      <>
        <Grid container>
          <Grid item lg={4}>
            {business && (
              <>
                <Alert severity="info" style={{ fontSize: "12px", backgroundColor: "#FAFAFA" }}>
                  <Typography variant="h6">Payment Token: </Typography>
                  <Typography>
                    Balance:
                    {business?.payeda_package?.payment_token?.balance || 0}
                  </Typography>
                  <Typography>
                    More Balance:
                    {business?.payeda_package?.payment_token?.more_token || 0}
                  </Typography>
                  <Typography>
                    Total Purchased:
                    {business?.payeda_package?.payment_token?.credit || 0}
                  </Typography>
                  <Typography>
                    Total Spent:
                    {business?.payeda_package?.payment_token?.debit || 0}
                  </Typography>
                </Alert>
                <small>
                  <strong>*Payment Token: </strong> Number of unpaid invoices to be paid by customers
                </small>
              </>
            )}
          </Grid>
          <Grid item lg={4}>
            {" "}
            {business && (
              <>
                {" "}
                <Alert severity="info" style={{ fontSize: "12px", backgroundColor: "#FAFAFA" }}>
                  <Typography variant="h6">Transfer Token: </Typography>
                  <Typography>
                    Balance:
                    {business?.payeda_package?.transfer_money_token?.balance || 0}
                  </Typography>
                  <Typography>
                    More Balance:
                    {business?.payeda_package?.transfer_money_token?.more_token || 0}
                  </Typography>
                  <Typography>
                    Total Purchased :{business?.payeda_package?.transfer_money_token?.credit || 0}
                  </Typography>
                  <Typography>
                    Total Spent:
                    {business?.payeda_package?.transfer_money_token?.debit || 0}
                  </Typography>
                </Alert>
                <small>
                  <strong>*Transfer Token: </strong> Number of transfer money can be made
                </small>
              </>
            )}
          </Grid>

          <Grid item lg={4}>
            {business && (
              <>
                {" "}
                <Alert severity="info" style={{ fontSize: "12px", backgroundColor: "#FAFAFA" }}>
                  <Typography variant="h6">Bank Token: </Typography>

                  <Typography>Balance: {business.payeda_package?.bank_token?.balance || 0}</Typography>
                  <Typography>Total Purchased: {business.payeda_package?.bank_token?.credit || 0}</Typography>
                  <Typography>Total Spent: {business.payeda_package?.bank_token?.debit || 0}</Typography>
                </Alert>
                <small>
                  <strong>*Bank Token: </strong> Number of bank accounts that can be connected to Payeda
                </small>
              </>
            )}
          </Grid>
        </Grid>

        <br />
      </>
    );
  };

  return (
    <BasePage navigation="Dashboard/Payeda Token Logs" business={business} canView={user?.permissions?.tokenSpending?.view}>
      {renderPackageInfo()}
      {renderTransactionsTable()}
      {/* {!tokenLogs || (tokenLogs.length === 0 && "No data found")} */}
    </BasePage>
  );
};

export default TransferMoney;
